import type { ReactNode } from 'react'

export function SectionHeader({ color, children }: { color: string; children: ReactNode }) {
  return (
    <div style={{
      padding: '16px 20px',
      backgroundColor: color,
      borderRadius: '8px 8px 0 0',
    }}>
      {children}
    </div>
  )
}

export function SectionBody({ children }: { children: ReactNode }) {
  return <div style={{ padding: '16px 20px' }}>{children}</div>
}
